<div
  (click)="goToDetails()"
  class="border-radius-8 or-bg-white or-pb-12-px or-px-12-px z-index-1 card-box-shadow or-pt-4-px"
  [class.or-cursor-pointer]="!isAnonymizedGame()"
  [class.or-mx-16-px]="marginsEnabled()">
  <div class="or-d-flex or-justify-content-between or-align-items-center or-mt-8-px">
    <div class="or-head-lg">{{ isAnonymizedGame() ? 'Gierka prywatna' : game().gameName }}</div>

    @if (showShareButton() && !isAnonymizedGame()) {
      <div class="or-d-flex">
        <or-icon name="copy-link" size="s" [shareGame]="game()" boxed class="or-color-white or-bg-main-1" />
      </div>
    }
    @if (showAddSimilarGame()) {
      <div class="or-d-flex">
        <div
          class="button-primary-style or-align-items-center or-d-flex or-h-32-px or-head-xs or-px-8-px"
          (click)="similarGameClicked($event)">
          Dodaj ponownie
        </div>
      </div>
    }
  </div>

  <div class="or-d-flex or-align-items-center or-mt-8-px">
    <or-icon name="clock" size="xxs" circle class="or-mr-8-px" />
    <div class="or-text-md">{{ game().formattedDate }}</div>
  </div>

  @if (!isAnonymizedGame()) {
    <div class="or-d-flex or-align-items-center or-mt-8-px">
      <or-icon name="location" size="xxs" circle class="or-mr-8-px" />
      <div class="or-text-md">{{ game().location.address }}, {{ game().location.city }}</div>
    </div>
  }

  @if (hostDetailsVisible()) {
    <div class="or-mt-8-px">
      <div class="or-d-flex or-justify-content-between or-align-items-center">
        <div class="or-ml-2-px or-d-flex or-align-items-center">
          <lib-or-avatar
            [avatarUrl]="game().host?.thumbnail"
            [avatarSize]="'xs'"
            [initials]="game().host?.displayName"></lib-or-avatar>
          <div class="or-head-xs">{{ game().host?.displayName }}</div>
          @if (hostRatingValue()) {
            <or-icon name="star" size="xs" class="or-ml-8-px or-mr-4-px or-color-yellow" />

            <div class="or-head-xs">{{ hostRatingValue() }}</div>
          }
        </div>
        <div>
          @if (showPhoneNumber()) {
            <button
              [copyToClipboard]="game().gameContactPhone"
              class="button-primary-style or-align-items-center or-d-flex or-head-md or-justify-content-between or-px-8-px or-h-32-px or-cursor-pointer"
              [class.disabled-button]="!game().gameContactPhone">
              <or-icon name="phone" size="xs" class="or-mr-4-px or-color-white" />

              <span class="or-color-white or-head-xs text-no-wrap" [class.disabled-button]="!game().gameContactPhone">
                Skopiuj numer
              </span>
            </button>
          }
        </div>
      </div>
    </div>
  }
  @if (showBottomDetails()) {
    <div class="custom-divider or-w-100-pc or-my-12-px"></div>

    <div class="or-d-flex or-justify-content-between or-align-items-center">
      <div class="or-d-flex or-align-items-center">
        <div class="or-d-flex or-align-items-center">
          <or-icon name="profile" size="xxs" circle class="or-mr-4-px" />
          <div class="or-text-md">
            {{ game().occupiedSlots }}/{{ game().totalSlots }}
            @if (isAdmin() && game().playerApplications?.length) {
              <span>({{ game().playerApplications?.length }})</span>
            }
          </div>
        </div>
        <div class="or-ml-12-px">
          <div class="or-d-flex or-align-items-center">
            <or-icon name="price" size="xxs" circle class="or-mr-4-px" />

            <div class="or-text-md">{{ game().priceAmount || 0 ? game().priceAmount + ' zł' : 'Darmowa' }}</div>
          </div>
        </div>
      </div>

      <div class="or-d-flex or-align-items-center">
        @if (cardBadge(); as badge) {
          <div
            class="or-px-8-px or-py-4-px border-radius-8 or-text-md or-d-flex or-justify-content-center or-align-items-center"
            [style.background-color]="badge.bgColor"
            [style.color]="badge.textColor">
            @if (badge.iconName) {
              <or-icon [name]="badge.iconName" size="s" class="or-mr-8-px" [style.color]="badge.textColor" />
            }
            {{ badge.displayName }}
          </div>
        }
      </div>
    </div>
  }
</div>
